import { styled } from "@mui/system";

import KpiStats from "./_components/kpi-stats";
import TransactionTrend from "./_components/transaction-trend";
import UserType from "./_components/user-distribution-type";
import TransactionPerformance from "./_components/transaction-performance";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const GridContainer = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "12px",
}));

export const Dashboard = () => {
  return (
    <SectionRoot>
      <KpiStats />
      <GridContainer>
        <TransactionTrend />
        <UserType />
      </GridContainer>
      <TransactionPerformance />
    </SectionRoot>
  );
};
